/**
 * Ultra Admin Utilities
 * Special privileges for specific users (e.g., john@osvald.com)
 */

import type { User } from '../types';

/**
 * Check if a user is an ultra admin
 * Ultra admins have special privileges:
 * - Access to all events
 * - Can edit/delete templates
 * - Can manage any event as admin
 */
export function isUltraAdmin(user: User | null): boolean {
  if (!user || !user.email) return false;
  
  // Check if email is "john@osvald.com" (case-insensitive)
  return user.email.toLowerCase() === 'john@osvald.com';
}

/**
 * Get ultra admin capabilities
 */
export function getUltraAdminCapabilities(user: User | null) {
  const isAdmin = isUltraAdmin(user);
  
  return {
    isUltraAdmin: isAdmin,
    canAccessAllEvents: isAdmin,
    canEditTemplates: isAdmin,
    canDeleteTemplates: isAdmin,
    canManageAnyEvent: isAdmin,
  };
}

